import { useTranslation } from 'react-i18next'
import { LuBanknote } from 'react-icons/lu'
import { BoxProps, Text } from '@chakra-ui/react'
import { OrderItem } from '@leid/api-orders'

import { getOrderItemDescriptionText, getOrderItemPriceText } from 'utils/priceDescription'
import { removeDecimals } from 'utils/removeDecimals'

import { ItemCardStylingProps } from '../../interfaces'
import { ItemCardSecondarySpan } from '../../styles'
import { ItemCardListItem } from '../ItemCardListItem'

type Props = {
  orderItem: OrderItem
} & ItemCardStylingProps &
  BoxProps

export const ItemCardPriceItem: React.FC<Props> = ({ orderItem, isBundle, ...boxProps }) => {
  const { t } = useTranslation(['common', 'statuses'])

  const stylingProps: ItemCardStylingProps = { isBundle }

  const { refund, price, rebateAmount, personalDiscount, rebateCause, rawPrice, deposit, depositUsed } = orderItem

  if (refund) {
    return (
      <ItemCardListItem luIcon={<LuBanknote size={12} />} {...stylingProps} {...boxProps}>
        <Text>
          {removeDecimals(price - refund)} {t('common:nok')}
          {' ('}
          <Text as="span" textDecoration="line-through">
            {removeDecimals(price)} {t('common:nok')}
          </Text>
          {')'}
        </Text>
      </ItemCardListItem>
    )
  }

  return (
    <>
      <ItemCardListItem luIcon={<LuBanknote size={12} />} {...stylingProps} {...boxProps}>
        {getOrderItemPriceText(price, rebateAmount, personalDiscount, t)}
        {(rebateAmount !== undefined || personalDiscount !== undefined) && (
          <Text fontSize="xs">
            {getOrderItemDescriptionText(rebateAmount, rebateCause, rawPrice, personalDiscount, t)}
          </Text>
        )}
      </ItemCardListItem>

      {deposit !== undefined && (
        <ItemCardListItem luIcon={<LuBanknote size={12} />} {...stylingProps} {...boxProps}>
          <Text fontSize="sm">
            <ItemCardSecondarySpan {...stylingProps}>{t('common:deposit')}: </ItemCardSecondarySpan>
            {removeDecimals(deposit)} {t('nok')}
          </Text>
        </ItemCardListItem>
      )}

      {depositUsed !== undefined && (
        <ItemCardListItem luIcon={<LuBanknote size={12} />} {...stylingProps} {...boxProps}>
          <Text fontSize="sm">
            <ItemCardSecondarySpan {...stylingProps}>{t('common:deposit')}: </ItemCardSecondarySpan>
            {removeDecimals(depositUsed)} {t('nok')}
          </Text>
        </ItemCardListItem>
      )}
    </>
  )
}
